import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/ploi/www.fara-kezmarok.sk/layouts/default.vue").then(m => m.default || m))
}